import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileCta } from './MobileCta';

export function PublicLayout({ children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <main id="main" tabIndex="-1" style={{ flex: 1 }}>{children}</main>
      <Footer />
      <MobileCta />
      <div style={{ height: 70 }} className="md:hidden" aria-hidden="true" />
    </div>
  );
}
